import { ReportsTranslations } from "../models/reports-translaction-model";

export const enUS: ReportsTranslations = {
  filter: {
    period: 'Period',
    dates: 'Dates',
    expandSearch: 'Expand Search Options',
    financialGroup: 'Financial Group',
    status: 'Status',
    clear: 'Clear Filters',
    search: 'Search',
    placeholders: {
      select: 'Select',
    },
    dateOptions: {
      lastSevenDays: 'Last 7 days',
      lastThirtyDays: 'Last 30 days',
      lastThreeMonths: 'Last 3 months',
      currentMonth: 'Current Month',
      custom: 'Custom',
      noDate: 'No Date Selected',
    },
    snackbar: {
      fillField: 'Fill in a field',
    },
    buttons: {
      cancel: 'Cancel',
      ok: 'OK',
    },
  },
  table: {
    noData: 'No data found.',
    tooltipError: 'Report error',
    headers: {
      reportLayout: 'Report Layout',
      reportName: 'File Name',
      financialGroup: 'Financial Group',
      requestedBy: 'Requested By',
      requestDate: 'Request Date',
      issueDate: 'Issue Date',
      status: 'Status',
      error: 'Error',
      actions: 'Actions',
    },
  },
  messages: {
    downloadSuccess: 'Download completed successfully.',
    downloadError: 'An error occurred while downloading.',
    fetchError: 'An error occurred while fetching reports.',
    noDataText: 'No data found.',
    loadingText: 'Loading...',
    noResultText: 'No result found.',
  },
  errorModal: {
    title: 'Report errors',
    headers: {
      description: 'Error Description',
      date: 'Date',
    },
  },
  status: {
    requested: 'Requested',
    processing: 'Processing',
    fail: 'Issuance Error',
    success: 'Issued Successfully',
  },
  reportLayouts: {
    reportMovementRecordDefault: 'Standard Enrollment Movement Report',
    reportMovementRecordAnalytical: 'Analytical Enrollment Movement Report',
    reportMovementRecordOperational: 'Operational Enrollment Movement Report',
    reportFileDataErrors: 'Error Report',
    reportFileDataCorrectionFile: 'Correction File',
    reportFileDataCriticismReturn: 'Criticism Return File',
  },
  defaults: {
    reportLayoutName: 'Beneficiary File',
  },
};
